<div class='language-select_container'>
  @if (label) {
    <span class='secondary-text language-select_label'>{{label}}</span>
  }
  <div class='language-select_lang-container'>
    @for (languageCode of languageCodes; track languageCode) {
      <span
        [matTooltip]='appService.supportedLanguages[languageCode] && appService.supportedLanguages[languageCode].description'
        class='language-select_lang'
        (click)='onClick(languageCode)'
        [class.active]='activeLanguageCodes && activeLanguageCodes.includes(languageCode)'
        [class.selected]='languageCode == selected'
        >
        <img [src]='"assets/images/flags/4x3/" + languageCode.toLocaleLowerCase() + ".svg"' />
      </span>
    }
  </div>
</div>